<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：修改管理员信息
    -->
    <div class="bg_add">
		<div class="changead">
			<div class="inputdata">
				<div class="changeadinput">
					<el-form label-width="80px" :model="formdata">
					  <el-form-item label="手机号" class="changeColor">
					    <el-input v-model="formdata.phone" placeholder="手机号" :maxlength="11"></el-input>
					  </el-form-item>
					  <el-form-item label="账号状态" class="changeColor" style="text-align: left;">
					    <el-select v-model="formdata.status" placeholder="请选择" >
						    <el-option
								v-for="item in types"
								:key="item.id"
								:label="item.label"
								:value="item.id">
							</el-option>
						 </el-select>
					  </el-form-item>
					  <el-form-item label="真实姓名" class="changeColor">
					    <el-input v-model="formdata.real_name" placeholder="真实姓名"></el-input>
					  </el-form-item>
					   <el-button type="primary" @click='sumbit()'>提交</el-button>
					   <el-button @click="pageback">取消</el-button>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'change-ad',
		props:['id'],
		data(){
			return {
				formdata:{
					admin_id:'',
					phone:'',
					status:'',
					real_name:'',
				},
				types:[
					{
						id:'0',
						label:'禁用'
					},
					{
						id:'1',
						label:'正常'
					}
				],
				placeholder:'',
			}
		},
		created:function(){
			this.idsave()
		},
		methods:{
			pageback(){
				this.$emit('pagechangefalse')
			},
			sumbit(){
				let phone = this.formdata.phone;
				let status = this.formdata.status;
				let realName = this.formdata.real_name;
				if(phone == '' || phone.length < 11)
				return this.$message({
					type:'warning',
					message:'请输入正确的手机号',
					duration:1000
				})
				
				if(status == '')
				return this.$message({
					type:'warning',
					message:'请输入账号状态',
					duration:1000
				})
				if(status === '正常')
					this.formdata.status = 1
				if(status === '禁用')
					this.formdata.status = 0
				if(realName == '')
				return this.$message({
					type:'warning',
					message:'请输入真实姓名',
					duration:1000
				})
				this.$jssdk.admin.edit(this.formdata ,(data) => {
					this.$message.success('修改成功')
					this.pageback()
					return
				},(err) =>{
					return this.$message.warning(err.msg)
				})
			},
			idsave(){
				this.formdata = this.id
				if(this.id.status == 1){
					 this.id.status = '正常';
				}else{
					this.id.status = '禁用'
				}
			}
		},
	}
</script>

<style scoped>
	.bg_add{
		background-color: rgba(0,0,0,.7);
		width: 100%;
		height: 965px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 6;
	}
	.changead{
		background-color: white;
		width:450px;
		position: absolute;
		left: 740px;
		top: 340px;
		color: white;
		z-index: 3;
		overflow: hidden;
		padding: 15px;
		border-radius: 15px;
		border:1px solid #ccc;
		box-shadow: 2px 2px 2px #000;
	}
	.changeadinput{
		width: 370px;
		color: red;
		margin: 0 auto;
		text-align: center;
		padding: 20px 0;
	}
	@media only screen and (max-width:1400px ) {
		.changead{
			background-color: white;
			width:450px;
			position: absolute;
			left: 440px;
			top: 140px;
			color: white;
			z-index: 3;
			overflow: hidden;
			padding: 15px;
			border-radius: 15px;
			border:1px solid #ccc;
			box-shadow: 2px 2px 2px #000;
		}
	}
</style>


// WEBPACK FOOTER //
// changeAdmin.vue?12efb3f4